export function blockGalleryLightbox() {
    document.querySelectorAll('.gallery-block').forEach((container) => {
        require("fslightbox");


        const items = container.querySelectorAll('.a');

        if(items > 0){
            const lightbox = new window.FsLightbox();
            lightbox.props.sources = [];

            items.forEach((item, key) => {
                lightbox.props.sources.push(item.getAttributeFilters('href'));
                item.addEventListener('click', e => {
                    e.preventDefault();
                    lightbox.open(key)
                })
            })
        }
    })
}